import { Flex, Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({ vertical: true, align: 'center', gap: '4px' })``;

export const Title = styled(Typography.Title).attrs({ level: 5 })`
  color: ${COLOR_OPTIONS.NEUTRAL_100};
`;

export const Description = styled(Typography.Text)`
  color: ${COLOR_OPTIONS.NEUTRAL_60};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.105px;
`;
